export default __webpack_public_path__ + "static/media/worldtour2.016f0863.PNG";